import { useState, useEffect } from 'react';

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

export function usePWAInstall() {
  const [deferredPrompt, setDeferredPrompt] = useState<BeforeInstallPromptEvent | null>(null);
  const [isSafari, setIsSafari] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent;
    
    // More reliable browser detection
    const isSafariBrowser = /Safari/i.test(userAgent) && !/Chrome/i.test(userAgent);
    setIsSafari(isSafariBrowser);

    // Check if app is already installed
    const isStandaloneMode = window.matchMedia('(display-mode: standalone)').matches ||
      (window.navigator as any).standalone ||
      document.referrer.includes('android-app://');
    setIsStandalone(isStandaloneMode);

    const handleBeforeInstallPrompt = (e: Event) => {
      e.preventDefault();
      setDeferredPrompt(e as BeforeInstallPromptEvent);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const install = async () => {
    if (isSafari) {
      alert('Para instalar o app no Safari:\n1. Toque no botão de compartilhar\n2. Role para baixo e toque em "Adicionar à Tela de Início"\n3. Toque em "Adicionar"');
      return;
    }

    if (!deferredPrompt) {
      // const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
      
      // if (isLocalhost) {
      //   alert(
      //     'Instalação no Chrome não está disponível em localhost.\n\n' +
      //     'Para testar a instalação do PWA:\n' +
      //     '1. Faça deploy do site em um servidor com HTTPS\n' +
      //     '2. Acesse o site algumas vezes para atender aos critérios de engajamento\n' +
      //     '3. O Chrome então permitirá a instalação automática ou via menu\n\n' +
      //     'Em produção, este botão funcionará corretamente quando o Chrome determinar que o usuário está engajado com o site.'
      //   );
      // } else if (navigator.userAgent.includes('Chrome')) {
      //   alert(
      //     'Instalação não disponível no momento.\n\n' +
      //     'O Chrome só permite a instalação do PWA após algumas visitas ao site.\n\n' +
      //     'Tente uma destas opções:\n' +
      //     '1. Visite o site mais algumas vezes\n' +
      //     '2. Verifique no menu (três pontos) se existe a opção "Instalar Ofertou..."'
      //   );
      // } else {
      //   alert('Seu navegador não suporta a instalação direta do app ou o app já está instalado.');
      // }
      return;
    }

    try {
      await deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        setDeferredPrompt(null);
      }
    } catch (error) {
      console.error('Error installing PWA:', error);
      alert('Erro ao instalar o app. Por favor, tente novamente.');
    }
  };

  // Always show install button for testing
  // const canInstall = !isStandalone;
  const canInstall = !isStandalone && (!!deferredPrompt || isSafari);
  
  return {
    canInstall,
    install,
    isSafari
  };
}